export class AccessDeniedError extends Error {
  constructor () {
    super('Sessão Expirada, faça o login novamente')
    this.name = 'AccessDeniedError'
  }
}
